import React from 'react';
import './Service.css';
import { motion } from 'framer-motion';

const ServiceThree = () => {
  const words = ['HOW', 'TO', 'SERVICE', 'YOUR', 'CAR']
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.5,
        ease: 'easeOut',
      },
    }),
  };
  return (
    <div className="service-three-container">
      <div className="service-three-left">
        <h2 className='chakra-petch-bold'>{words.map((word, i) => (
          <motion.span
            key={i}
            custom={i}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.8 }}
            variants={fadeInUp}
            style={{ display: 'inline-block', marginRight: '0.5rem' }}
          >
            {word}
          </motion.span>
        ))}</h2>
        <p className='font-mulish'>
          Rather than letting your services go by, take these steps to keep your car in good shape until you can afford a full service.
        </p>
      </div>
      <div className="service-three-right">
        <div className="step-box">
          <span className="step-number">01</span>
          <div>
            <h4 className='chakra-petch-bold'>MAKE AN APPOINTMENT</h4>
            <p className='font-mulish'>
              EXER MOTORS has made it easy to schedule an appointment online at a location near you in a few simple steps, easy schedule for customers.
            </p>
          </div>
        </div>
        <div className="step-box">
          <span className="step-number">02</span>
          <div>
            <h4 className='chakra-petch-bold'>SELECT SERVICE</h4>
            <p className='font-mulish'>
              We specialize in car services and have more than 20 years of experience in cars. We are car guys from day one. We love and respect cars.
            </p>
          </div>
        </div>
        <div className="step-box">
          <span className="step-number">03</span>
          <div>
            <h4 className='chakra-petch-bold'>CONFIRM REQUEST</h4>
            <p className='font-mulish'>
              Has your request been confirmed? Reduce no-shows, save time, and focus on serving clients is our top criterion.
            </p>
          </div>
        </div>
        <div className="step-box">
          <span className="step-number">04</span>
          <div>
            <h4 className='chakra-petch-bold'>GET YOUR CAR</h4>
            <p className='font-mulish'>
              It is a vehicle inspection that keeps your car in a reliable, safe and fully-functioning condition based on guidelines set out by the vehicle.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceThree;
